/*
 *
 * Options
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { createStructuredSelector } from 'reselect';
import { languageSelector, countrySelector } from 'domain/LanguageProvider/selectors';
import { setHasSeenNewFeatures } from 'domain/LocalStorage/actions';
import FullscreenLoading from 'ui/FullscreenLoading';
import FullscreenError from 'ui/FullscreenError';

import PriceDifferenceDialog from 'ui/Dialog/PriceDifferenceDialog';
import NewFeaturesDialog from 'ui/Dialog/NewFeaturesDialog';
import { TransitionGroup } from 'react-transition-group';
import Fade from 'ui/Fade';
import { showNewFeaturesDialogSelector, ipexGalleryModeSelector } from 'Application/selectors';
import { showNewFeaturesDialog as showNewFeaturesDialogAction, showNewFeaturesToast } from 'Application/actions';
import { loadingSelector, errorSelector, planLoadingSelector } from './selectors';
import { loadData, checkForNewFeatures } from './actions';
import messages from './messages';

import reducer from './reducer';
import saga from './sagas';

export class Options extends React.Component { // eslint-disable-line react/prefer-stateless-function

  UNSAFE_componentWillMount() {
    this.props.dispatch(loadData(this.props.country, this.props.language));
    this.props.dispatchCheckForNewFeatures();
  }

  onDismissNewFeaturesSeen = () => {
    this.props.dismissNewFeaturesDialog();
    this.props.dismissNewFeaturesToast();
  }

  onDismissNewFeaturesDialog = () => {
    this.props.dismissNewFeaturesDialog();
  }

  render() {
    const {
      loading,
      error,
      planLoading,
      showNewFeaturesDialog,
      cwcalcReachedFromIpexGallery,
    } = this.props;

    return (
      <div>
        <TransitionGroup>
          { error && (
          <Fade inProps={!!error}>
            <FullscreenError>{`Failed to: ${error}`}</FullscreenError>
          </Fade>
        )}

          <Fade inProps={!loading && !error && !planLoading}>
            {!loading && !planLoading && !error ? (
              <div>
                {React.Children.only(this.props.children)}
                <PriceDifferenceDialog cwcalcReachedFromIpexGallery={cwcalcReachedFromIpexGallery}/>
                <NewFeaturesDialog show={showNewFeaturesDialog} onDismiss={this.onDismissNewFeaturesDialog} onDismissNewFeaturesSeen={this.onDismissNewFeaturesSeen} cwcalcReachedFromIpexGallery={cwcalcReachedFromIpexGallery}/>
              </div>
            ) : null}
          </Fade>
        </TransitionGroup>
        { (loading || planLoading) && !error && <FullscreenLoading text={planLoading ? messages.loadingPlan : null} noFadeIn={planLoading} /> }
      </div>
    );
  }
}

Options.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  loading: PropTypes.bool.isRequired,
  planLoading: PropTypes.bool.isRequired,
  showNewFeaturesDialog: PropTypes.bool.isRequired,
  dispatchCheckForNewFeatures: PropTypes.func.isRequired,
  dismissNewFeaturesDialog: PropTypes.func.isRequired,
  dismissNewFeaturesToast: PropTypes.func.isRequired,
  error: PropTypes.string,
};

Options.defaultProps = {
  error: null,
  currentPrice: null,
};

const mapStateToProps = createStructuredSelector({
  loading: loadingSelector,
  error: errorSelector,
  language: languageSelector,
  country: countrySelector,
  planLoading: planLoadingSelector,
  showNewFeaturesDialog: showNewFeaturesDialogSelector,
  cwcalcReachedFromIpexGallery: ipexGalleryModeSelector,
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    dispatchCheckForNewFeatures: () => {
      dispatch(checkForNewFeatures());
    },
    dismissNewFeaturesDialog: () => {
      dispatch(showNewFeaturesDialogAction(false));
    },
    dismissNewFeaturesToast: () => {
      dispatch(showNewFeaturesToast(false));
      dispatch(setHasSeenNewFeatures(true));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: 'businessRules', reducer });
const withSaga = injectSaga({ key: 'businessRules', saga });

const EnhancedOptions = compose(
  withReducer,
  withSaga,
  withConnect,
)(Options);

export default EnhancedOptions;
